<template>
  <div id="global-scan" class="modal_pageview scan-modal slideup modelslideup">
    <div class="model-header" v-if="$route.query.isScanner !== 'scan'">
      <h2 @click="closeScanner"><span class="material-icons">
close
</span></h2>
    </div>
    <div class="modal-midbox">
      <div class="order-idbox">
        <div class="field-row" v-if="!isGlobalScanner">
          <label class="text-label">आर्डर आईडी</label>
          <input
            iType="text"
            name="orderId"
            value=""
            class="input-style"
            placeholder="ऑर्डर आईडी नंबर दर्ज करेंं"
            @input="getOrderIdFromInput"
          />
        </div>
      </div>
      <div class="scan_box">
        <div class="scan-msg">
          <p>QR कोड स्कैन करें</p>
        </div>
        <div class="glob-scanner">
          <qrcode-stream v-if="isScannerOpen" @decode="getBarcode" @init="onInit" :camera="camera" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getMediaPermission } from "../utils/helper";
import { QrcodeStream } from 'vue-qrcode-reader'
import Vue from 'vue'
export default {
  props: ["isGlobalScanner"],
  components: {
    QrcodeStream
  },
  data() {
    return {
      bar_code: false,
      orderId: "",
      error: '',
      bus: new Vue(),
      camera: 'auto',
      isScannerOpen:false
    };
  },

  methods: {
    submit() {
      this.bus.$emit('submit')
    },
    getOrderIdFromInput(_event) {
      if (_event.target.value) {
        this[_event.target.name] = _event.target.value;
      } else {
        this.bar_code = false;
        this[_event.target.name] = "";
      }
    },

    getBarcode(data) {
      this.bar_code = data
      console.log(this.bar_code.split("ide=")[1])
      this.$emit("orderId", this.bar_code.split("ide=")[1]);
    },

    closeScanner() {
      this.$emit("closeScanner");
    },
    async onInit (promise) {
      try {
        await promise
        promise.catch(error => {
        const cameraMissingError = error.name === 'OverconstrainedError'
        const triedFrontCamera = this.camera === 'front'

        if (triedFrontCamera && cameraMissingError) {
          // no front camera on this device
        }
      })
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = "ERROR: you need to grant camera access permisson"
        } else if (error.name === 'NotFoundError') {
          this.error = "ERROR: no camera on this device"
        } else if (error.name === 'NotSupportedError') {
          this.error = "ERROR: secure context required (HTTPS, localhost)"
        } else if (error.name === 'NotReadableError') {
          this.error = "ERROR: is the camera already in use?"
        } else if (error.name === 'OverconstrainedError') {
          this.error = "ERROR: installed cameras are not suitable"
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = "ERROR: Stream API is not supported in this browser"
        }
      }
      
    }
  },
  async mounted() {
    let _this = this;
    __native_money91.checkForPermissionResult = (result) => {
    if (result.length) {
      alert('कृपया कैमरा को  अनुमति दें');
      this.isScannerOpen = false
      this.closeScanner()
    }
    this.isScannerOpen=true;
  };
  // To allow JSbridge media permission
  const _ = ["android.permission.CAMERA"];
  try {
   return JSBridgePlugin.checkForPermission(
      _,
      true,
      "__native_money91.checkForPermissionResult"
    );
  } catch (err) {
    alert('एप्लिकेशन को सुचारू रूप से एक्सेस करने के लिए कृपया सभी मीडिया अनुमति प्रदान करेंं')
  }
  },
};
</script>
<style lang="scss" scoped>
.qrcode-stream-camera{
  width: 100%;
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    -o-object-fit: contain;
    object-fit: contain;
    -o-object-position: top;
    object-position: top;
}
</style>